import {EzAppLayout, EzThemeProvider} from '@ezcater/recipe';
import {Tooltip} from '@ezcater/tapas';
import LazyMotion from './components/LazyMotion';
import Routes from './Routes';
import ErrorBoundary from './components/ErrorBoundary';
import {AssignmentsProvider} from './services/eppo';
import theme from './theme';
import './i18n';

const App = () => (
  <Tooltip.Provider>
    <LazyMotion>
      <EzThemeProvider theme={theme}>
        <EzAppLayout>
          <ErrorBoundary>
            <AssignmentsProvider>
              <Routes />
            </AssignmentsProvider>
          </ErrorBoundary>
        </EzAppLayout>
      </EzThemeProvider>
    </LazyMotion>
  </Tooltip.Provider>
);

export default App;
